import $ from 'jquery'
import slick from 'slick-carousel'
import LazyLoad from "vanilla-lazyload"
import ScrollMagic from 'scrollmagic'
import ModalVideo from 'modal-video'
import superfish from 'superfish'

/* SETUP SLICK
  ----------------------------- */
export const setupSlideshow = (el, type = 'fullwidth') => {
  const $el = $(el);
  const opts = {
    fullwidth: {
      autoplay: true,
      dots: true,
      arrows: false,
      infinite: true,
      fade: false,
      lazyLoad: 'ondemand',
    },
    references: {
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      dots: false,
      arrows: true,
      infinite: true,
      fade: false,
      asNavFor: '.section__slide--nav',
      responsive: [
    {
      breakpoint: 1024,
      settings: {
      arrows: false,
      }
    },
    ]
    },
    nav: {
      slidesToShow: 4,
      slidesToScroll: 1,
      asNavFor: '.section__slide--main',
      dots: false,
      arrows: false,
      focusOnSelect: true,
      responsive: [
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
      }
    },
    ]
    }
  }

  $el.slick(opts[type])
}

/* LAZY LOAD
  ----------------------------- */
export const lazyLoad = () => {
  const lazyLoadInstance = new LazyLoad({
    elements_selector: ".lazy",
    data_src: "lazy",
  })
}


/* SMOOTH SCROLL
  ----------------------------- */
export const smoothScroll = () => {
  $('a[href*="#"]:not([href="#"]):not([href="#top"])').click(function() {
    const target = $(this.hash)
    $('html, body').animate({ scrollTop: target.offset().top-120 }, 600)
    return false
  })

  $("a[href='#top']").click(function() {
    $("html, body").animate({ scrollTop: 0 }, 800)
    return false
  })
}

/* HEADER ANIMATION
  ----------------------------- */
export const menuOverlay = () => {
  const toggle = $('.header__toggle')
  const bar = $('.header__toggle .bar')
  const overlay = $('.header--offcanvas, .header__inner, .content-area, body')
  const link = $('.header--offcanvas a');
  const header = $('.header--main');

  toggle.on('click', function () {
    overlay.toggleClass('open')
    bar.toggleClass('animate')
    toggle.toggleClass('open')
  })

  link.on('click', function () {
    overlay.removeClass('open')
    bar.removeClass('animate')
    toggle.removeClass('open')
  })

  window.onresize = () => {
    overlay.removeClass('open')
    bar.removeClass('animate')
    toggle.removeClass('open')
  }

  $(window).scroll(function(e) {
    $(document).scrollTop() > 200 ?
      header.addClass('sticky') :
      header.removeClass('sticky')

    this.oldScroll > this.scrollY ?
      header.addClass('sticky-show').removeClass('sticky-hide') :
      header.addClass('sticky-hide').removeClass('sticky-show')
    this.oldScroll = this.scrollY
  })
}

/* HEADER ANIMATION
  ----------------------------- */
export const childMenu = () => {
  const $toggle = $('.menu-item-has-children')
  const $submenu = $('.sub-menu')

  $toggle.mouseover(function() {
    $('.sub-menu').removeClass('open');
    $( this ).find( ".sub-menu" ).addClass('open');
    $('.header__collection').removeClass('open');
  })

  $submenu.on('mouseleave', function() {
   $( this ).removeClass('open');
 })

  $(window).on('resize scroll', function() {
    $submenu.removeClass('open')
  })
}

/* MENU PRODUCTS CATEGORIES
  ----------------------------- */
  export const displayBlock = () => {
    const $toggle = $('.menu-item-collection, .header__collection')
    const $block = $('.header__collection')

    $toggle.hover(function() {
      $block.addClass('open');
      $('.sub-menu').removeClass('open');
    })
    $block.on('mouseleave', function() {
     $block.removeClass('open');
  });
  }


/* SETUP MODALVIDEO
  ----------------------------- */
export const setupModalVideo = () => {
  if ($('.js-modal-btn').length > 0 || $('.js-modal-btn-vimeo').length > 0) {
    new ModalVideo('.js-modal-btn')
    new ModalVideo('.js-modal-btn-vimeo', { channel: 'vimeo' })
  }
}

/* SETUP FACETWP
  ----------------------------- */
export const setupProductFacet = () => {
  hideProducts()

  $(document).on('facetwp-loaded', function() {
    hideProducts()
  })

  $(document).on('facetwp-refresh', function() {
    hideProducts()
  })

  function hideProducts() {
    $('.post-type-archive-product .page__item, .post-type-archive-product .page__category-wrapper .container, .post-type-archive-product .page__subcategory-wrapper').hide()
    $('.facetwp-template .facetwp-product').each(function(index) {
      $($(this).attr('rel')).show().parents('.page__subcategory-wrapper').show().parents('.container').show()
    })
  }
}


// WEBPACK FOOTER //
// ./src/js/functions.js